import axios from 'axios';
import _get from 'lodash/get';

import store from 'store';

import { getNotificationsCount } from 'store/services/notifications/actions';
import { getProjectInnerPageParamsSelector } from 'store/services/router/selectors';

import Common from '../Common';

// reqInterceptor is not defined as class method because we can not refer to 'this'
// pointer before calling super()
const reqInterceptorHandler = async config => {
  const { company, project } = getProjectInnerPageParamsSelector(
    store.getState(),
  );

  return {
    ...config,
    url: `${company}/projects/${project}${config.url}`,
  };
};

const resInterceptorErrorHandler = error => {
  const status = _get(error, 'response.status', 400);

  // We ask for new unread notifications
  // And axios catches an error response that is not a throttled error (429)
  // And axios is not cancelled.
  if (!axios.isCancel(error) && status !== 429) {
    store.dispatch(getNotificationsCount());
  }
};

export default class Project extends Common {
  constructor(config = {}) {
    super(config, {
      reqInterceptor: reqInterceptorHandler,
      resErrorInterceptor: resInterceptorErrorHandler,
    });
  }
}
